/** 全局阈值ACK同步各风控缓存；App启停及其同源编辑元数据不由全局响应覆盖。 */
import type { RiskRuleV1Response } from '@novel-admin/shared';
import type { QueryClient } from '@tanstack/react-query';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** 仅识别已使用的legacy/scoped key与两种行形状；不创建新缓存、不猜测App覆盖来源。 */
export function reconcileRiskRuleThresholdCaches(client: QueryClient, dto: RiskRuleV1Response) {
  for (const [key, value] of client.getQueriesData<unknown>({ queryKey: ['risk-rules'] })) {
    if (
      !Array.isArray(value) ||
      !(key.length === 1 || (key.length === 2 && typeof key[1] === 'string'))
    )
      continue;
    const global = key.length === 1 || key[1] === 'all';
    client.setQueryData(
      key,
      value.map((row: unknown) => {
        if (!isRecord(row) || row.id !== dto.id) return row;
        // UI缓存是camelCase；legacy wire缓存保持snake_case及其原动作值域。
        if (typeof row.conditionDimension === 'string' && 'conditionValue' in row) {
          return {
            ...row,
            conditionValue: dto.condition_value,
            condition: dto.condition,
            ...(global ? { updatedBy: dto.updated_by_name ?? '—', updatedAt: dto.updated_at } : {}),
          };
        }
        if (typeof row.condition_dimension === 'string' && 'condition_value' in row) {
          return {
            ...row,
            condition_value: dto.condition_value,
            condition: dto.condition,
            ...(global
              ? {
                  updated_by: dto.updated_by,
                  updated_by_name: dto.updated_by_name,
                  updated_at: dto.updated_at,
                }
              : {}),
          };
        }
        return row;
      }),
    );
  }
}
